import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import moment from 'moment';

import DataHelper from '../../library/DataHelpers';


export default class JobDayHistoryTable extends Component {

    constructor(props) {
        super(props) ;

        this.onHistoryRowSelect = this.onHistoryRowSelect.bind(this);
        this.state = {
            selected : null
        }
    }

    timeFormatter(cell, row) {
        if (!cell) {
            return "";
        }
        return moment.utc(cell, 'YYYYMMDDHHmmss').local().format("MM/DD/YYYY HH:mm");
    }

    onHistoryRowSelect(row,isSelected,e) {
        if (this.props.onSelect) {
            this.setState({selected: row.time});
            this.props.onSelect(row);
        }
        return true ;
    }

     tripFormatter(cell, row) {
        if (!row || !row.status) {
            return "" ;
        }

        return `${row.status.trip0 || ""}` ;
    }

    render() {
        const selectRowProp = {
            mode: 'radio',
            bgColor: 'lightblue',
            clickToSelect: true,
            selected: [this.state.selected], // default select on table
            onSelect: this.onHistoryRowSelect
        };

        const options = {
            sortName: 'time',  // default sort column name
            sortOrder: 'asc',  // default sort order
            sizePerPage: 10,
            hideSizePerPage: true,
        };

        console.log("DAY LIST= ", this.props.history) ;

        return (
            <div>
                <BootstrapTable data={ this.props.history }
                    selectRow={ selectRowProp }
                    options={ options }
                    hover focus search pagination
                    tableContainerClass='orbit-table-container'>

                    <TableHeaderColumn dataField='time'  dataFormat={ this.timeFormatter } isKey >Event Time</TableHeaderColumn>
                    <TableHeaderColumn dataField='jobstate' >Status</TableHeaderColumn>
                    <TableHeaderColumn dataField='trip' dataFormat={ this.tripFormatter } >Trip</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}






// WEBPACK FOOTER //
// ./src/app/components/jobs/jobDayHistoryTable.js